import { AnimatePresence, motion } from "motion/react";
import type { SurfaceTab } from "../api/types";
import { TAB_HINTS, TAB_ICONS } from "../utils/tabHints";

type Props = {
  tab: SurfaceTab;
};

/** Compact one-line tab purpose — minimal vertical footprint. */
export default function PromoteSurfaceTabHint({ tab }: Props) {
  const hint = TAB_HINTS[tab];
  const Icon = TAB_ICONS[tab];

  return (
    <div className="flex shrink-0 justify-center px-3 pb-1.5">
      <AnimatePresence mode="wait" initial={false}>
        <motion.p
          key={tab}
          role="status"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.12 }}
          className="inline-flex max-w-2xl items-center gap-1.5 text-center text-[11px] leading-tight text-muted-foreground sm:text-xs"
        >
          <Icon className="h-3 w-3 shrink-0 text-primary/80" aria-hidden strokeWidth={2.25} />
          <span>
            <span className="font-medium text-foreground/90">{hint.title}. </span>
            <span>{hint.body}</span>
          </span>
        </motion.p>
      </AnimatePresence>
    </div>
  );
}
